import { useState } from 'react';
import { Pencil, Lightbulb } from 'lucide-react';
import { C } from '../config/constants';

export default function AdminBar({ onLogout, saving }) {
  const [expanded, setExpanded] = useState(true);
  return (
    <div style={{
      position:'fixed', bottom:'1.5rem', right:'1.5rem', zIndex:1100,
      background:'#0f1e35', border:`1px solid rgba(255,215,0,0.25)`,
      boxShadow:'0 8px 32px rgba(0,0,0,0.4)',
      minWidth: expanded ? '210px' : '44px',
      overflow:'hidden', transition:'all 0.3s',
    }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
        padding:'0.75rem 1rem', cursor:'pointer', userSelect:'none' }}
        onClick={()=>setExpanded(p=>!p)}>
        <span style={{ color:C.groc, fontWeight:700, fontSize:'0.82rem',
          whiteSpace:'nowrap', overflow:'hidden',
          maxWidth: expanded ? '160px' : '0px', transition:'max-width 0.3s',
          letterSpacing:'0.04em', display:'flex', alignItems:'center', gap:6 }}>
          <Pencil size={13}/> Administrador</span>
        <span style={{ color:'rgba(255,215,0,0.5)', fontSize:'0.7rem',
          transform: expanded ? 'rotate(0)' : 'rotate(180deg)', transition:'transform 0.3s' }}>▼</span>
      </div>
      {expanded && (
        <div style={{ padding:'0 1rem 1rem', display:'flex', flexDirection:'column', gap:'0.65rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'0.75rem' }}>
            <div style={{ width:7, height:7, borderRadius:'50%', flexShrink:0,
              background: saving ? '#ffc107' : '#28a745',
              boxShadow: saving ? '0 0 6px #ffc107' : '0 0 6px #28a745' }}/>
            <span style={{ color:'rgba(255,255,255,0.5)' }}>
              {saving ? 'Desant...' : 'Tots els canvis desats'}
            </span>
          </div>
          <div style={{ height:1, background:'rgba(255,255,255,0.07)' }}/>
          <p style={{ fontSize:'0.72rem', color:'rgba(255,255,255,0.35)', lineHeight:1.5,
            display:'flex', alignItems:'flex-start', gap:6 }}>
            <Lightbulb size={14} style={{ flexShrink:0, marginTop:1 }}/>
            Clica textos o imatges per editar
          </p>
          <button onClick={onLogout} style={{
            background:'rgba(255,255,255,0.07)', color:'rgba(255,215,0,0.7)',
            border:'1px solid rgba(255,215,0,0.2)',
            padding:'0.45rem 0.85rem', fontWeight:600,
            fontSize:'0.75rem', cursor:'pointer', fontFamily:'inherit',
            letterSpacing:'0.04em', transition:'all 0.2s',
          }}
            onMouseEnter={e=>e.target.style.background='rgba(255,255,255,0.12)'}
            onMouseLeave={e=>e.target.style.background='rgba(255,255,255,0.07)'}
          >Sortir del mode admin</button>
        </div>
      )}
    </div>
  );
}